<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">服务</div></div>
                <div class="title">咨询</div>
                <div class="minTitle">为客户提供完整的QA质量体系咨询服务，包括建立流程体系、过程改进与优化、培训与推广、流程执行与质量控制等咨询服务</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
      
       <picture>
            <source srcset="@/assets/images/zx_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/zx.png" />
        </picture>
       <div class="title tc" :class="tab == 1? 'bg1': 'bg2'">
            <div class="titleNav">
                <div class="item" :class="tab == 1? 'active': ''" @click="tab = 1">QA质量体系咨询</div>
                <div class="item" :class="tab == 2? 'active': ''" @click="tab = 2">大数据咨询</div>
            </div>
       </div>
       <div v-show="tab == 1">
            <div class="con1 bg1">
                <div class="content">
                    <img class="img1" src="@/assets/images/zx1.png" />
                    <div class="content1">
                        <div class="title3">建立流程体系</div>
                        <div class="minTitle2 mt10">根据项目类型和项目规模划分项目；</div>
                        <div class="minTitle2 mt5">建立多种项目流程以满足不同特性的项目管理需求。</div>
                    </div>
                </div>
            </div>
            <div class="con1 bg2">
                <div class="content">
                    <div class="content2">
                        <div class="title3">过程改进与优化</div>
                        <div class="minTitle2 mt10">现有流程的持续优化与不断改进</div>
                        <div class="minTitle2 mt5">新流程的建立与推广</div>
                    </div>
                    <img class="img2" src="@/assets/images/zx2.png" />
                </div>
            </div>
            <div class="con1 bg1">
                <div class="content">
                    <img class="img3" src="@/assets/images/zx3.png" />
                    <div class="content3">
                        <div class="title3">培训与推广</div>
                        <div class="minTitle2 mt10">提炼经验教训，建立知识库；</div>
                        <div class="minTitle2 mt5">编写与优化培训教材；涵盖：流程、工具、技能等；</div>
                        <div class="minTitle2 mt5">根据培训计划执行培训；包含：流程推广、工具使用、技能提升等培训；</div>
                        <div class="minTitle2 mt5">统计培训的有效性；采集和分析培训需求；</div>
                        <div class="minTitle2 mt5">设定各类培训评价指标以检验是否达到培训目。</div>
                    </div>
                </div>
            </div>
            <div class="con1 bg2">
                <div class="content">
                    <div class="content4">
                        <div class="title3">流程执行与质量控制</div>
                        <div class="minTitle2 mt10">项目裁剪、质量分析、QA审计、里程碑会议</div>
                    </div>
                    <img class="img2" src="@/assets/images/zx4.png" />
                </div>
            </div>
            <div class="con1 bg1">
                <div class="content">
                    <img class="img5" src="@/assets/images/zx5.png" />
                    <div class="content5">
                        <div class="title3">建立度量库与度量基线</div>
                        <div class="minTitle2 mt10">广度度量—广泛覆盖</div>
                        <div class="minTitle2 mt5">深度度量—项目指标</div>
                    </div>
                </div>
            </div>
            <div class="con1 bg2">
                <div class="content">
                    <div class="content6">
                        <div class="title3">工具的使用与优化</div>
                        <div class="minTitle2 mt10">文档控制、项目管理、绩效调研、各类周边系统</div>
                        <div class="minTitle2 mt5">提升效率，收集与提供系统改进建议</div>
                    </div>
                    <img class="img6" src="@/assets/images/zx6.png" />
                </div>
            </div>
       </div>
       <div v-show="tab == 2" class="bg2 pb20">
            <div class="content bg1 itemC">
                <div class="title">
                    <img src="@/assets/images/dsj1.png" />
                    <span class="title3">面临的问题</span>
                </div>
                <div class="flex">
                    <div class="w25 myMl minTitle2">
                        <div class="title2 mt15">数据多：整合困难</div>
                        <div class="texts mt10">
                            <span class="span1">·数据来源多样化</span>
                            <span class="span1">·数据类型复杂性 </span>
                        </div>
                        <div class="texts mt5">
                            <span class="span1">·数据特征多元化</span>
                            <span class="span1">·数据处理方法差异化 </span>
                        </div>
                        <div class="texts mt5">
                            <span class="span1">·组织数据分散性</span>
                            <span class="span1">·数据共享机制缺乏 </span>
                        </div>
                    </div>
                    <div class="w40 minTitle2">
                        <div class="title2 mt15">客户多：分析困难</div>
                        <div class="texts mt10">
                            <span class="span2">·如何识别客户全方位特征？</span>
                            <span class="span3">·怎样有效细分客户？ </span>
                        </div>
                        <div class="texts mt5">
                            <span class="span2">·怎样提取客户共性需求？</span>
                            <span class="span3">·怎样利用模型和算法生产客户多样化标签？ </span>
                        </div>
                        <div class="texts mt5">
                            <span class="span2">·怎样进行客户行为偏好分析？</span>
                        </div>
                    </div>
                    <div class="w32 minTitle2">
                        <div class="title2 mt15">需求多：应用困难</div>
                        <div class="texts mt10">
                            <span class="span1">·如何与客户实时交互？</span>
                            <span class="span1">·如何及时响应客户需求？ </span>
                        </div>
                        <div class="texts mt5">
                            <span class="span1">·如何提供满意的客户体验？</span>
                            <span class="span1">·如何降低客户流失？ </span>
                        </div>
                        <div class="texts mt5">
                            <span class="span1">·如何控制客户维系成本？</span>
                            <span class="span1">·如何对客户进行精准营销？ </span>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="content bg1 itemC mt15">
                <div class="title">
                    <img src="@/assets/images/dsj2.png" />
                    <span class="title3">数字化运营解决的关键问题：</span>
                </div>
                <div class="flex">
                    <div class="w15 myMl">
                        <div class="title2 mt15">·高效获得新客源</div>
                    </div>
                    <div class="w15">
                        <div class="title2 mt15">·快速优化交易环节</div>
                    </div>
                    <div class="w15">
                        <div class="title2 mt15">·成功激活老客户</div>
                    </div>
                    <div class="w15">
                        <div class="title2 mt15">·数字化供应链</div>
                    </div>
                    <div class="w15">
                        <div class="title2 mt15">·形成营销闭环</div>
                    </div>
                    <div class="w15">
                        <div class="title2 mt15">·提高客户忠诚度</div>
                    </div>
                </div>
            </div>
            <div class="content bg1 itemC mt15">
                <div class="title">
                    <img src="@/assets/images/dsj3.png" />
                    <span class="title3">数字化运营的益处：</span>
                </div>
                <div class="flex">
                    <div>
                        <div class="w22 myMl">
                            <div class="title2 mt15">·运营监控数字化</div>
                        </div>
                        <div class="w22">
                            <div class="title2 mt15">·用户分类精细化</div>
                        </div>
                        <div class="w22">
                            <div class="title2 mt15">·激活老用户高效化</div>
                        </div>
                        <div class="w22">
                            <div class="title2 mt15">·充分利用数据进行价值深挖</div>
                        </div>
                    </div>
                    <div>
                        <div class="w22 myMl">
                            <div class="title2 mt5">·客户感知个性化、多元化</div>
                        </div>
                        <div class="w22">
                            <div class="title2 mt5">·提前洞察市场变化趋势</div>
                        </div>
                        <div class="w22">
                            <div class="title2 mt5">·准确无误地进行风险评估</div>
                        </div>
                        <div class="w22">
                            <div class="title2 mt5">·灵活、实时、准确地制定决策</div>
                        </div>
                    </div>
                    <div>
                        <div class="w22 myMl">
                            <div class="title2 mt5">·精准营销、节省成本</div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                tab: 1
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .bg1 {
            background-color: #ffffff;
        }
        .bg2 {
            background-color: #F5F7FA;
            overflow: hidden;
        }
        .pb20 {
            padding-bottom: 20px;
        }
        .itemC {
            padding: 25px 20px 30px 20px;
        }
        .mt15 {
            margin-top: 15px;
        }
        .w40 {
            float: left;
            width: 40%;
        }
        .w15 {
            float: left;
            width: 15%;
        }
        .w22 {
            float: left;
            width: 22%;
        }
        .w25 {
            float: left;
            width: 25%;
        }
        .w32 {
            float: left;
            width: 30%;
        }
        .myMl {
            margin-left: 50px;
        }
        .span1 {
            display: inline-block;
            width: 49%;
        }
        .span2 {
            display: inline-block;
            width: 40%;
        }
        .span3 {
            display: inline-block;
            width: 59%;
        }
        .titleNav {
            padding: 5px 8px;
            display: inline-block;
            margin: 20px;
            border: 1px solid #6BDEFF;
            border-radius: 50px;
            .item {
                display: inline-block;
                font-size: 20px;
                color: #333333;
                width: 170px;
                border-radius: 40px;
                padding: 10px;
                cursor: pointer;
            }
            .item:hover {
                color: #F40010;
            }
            .active:hover {
                color: #ffffff;
            }
            .active {
                color: #ffffff;
                background: -webkit-linear-gradient(right, #6BDEFF, #3C91FF);
                background: -o-linear-gradient(right, #6BDEFF, #3C91FF);
                background: -moz-linear-gradient(right, #6BDEFF, #3C91FF);
                background: linear-gradient(to right,#6BDEFF, #3C91FF);
            }
        }
        .content {
            zoom: 1;
            overflow: hidden;
            .title {
                img {
                    height: 35px;
                    width: 35px;
                    margin-right: 15px;
                }
                span {
                    line-height: 40px;
                    vertical-align: bottom;
                }
            }
            .img1 {
                float: left;
                height: 320px;
                margin-left: 16%;
                padding: 20px;
            }
            .content1 {
                float: left;
                margin-left: 10%;
                margin-top: 120px;
            }
            .img2 {
                float: left;
                height: 234px;
                margin-left: 9%;
                padding: 40px;
            }
            .content2 {
                float: left;
                margin-left: 22%;
                margin-top: 120px;
            }
            .img3 {
                float: left;
                height: 252px;
                margin-left: 7%;
                padding: 40px;
            }
            .content3 {
                float: left;
                margin-left: 0.5%;
                margin-top: 100px;
            }
            .img4 {
                float: left;
                height: 265px;
                margin-left: 9%;
                padding: 40px;
            }
            .content4 {
                float: left;
                margin-left: 22%;
                margin-top: 130px;
            }
            .img5 {
                float: left;
                height: 255px;
                margin-left: 10%;
                padding: 40px;
            }
            .content5 {
                float: left;
                margin-left: 7%;
                margin-top: 130px;
            }
            .img6 {
                float: left;
                height: 280px;
                margin-left: 9%;
                padding: 40px;
            }
            .content6 {
                float: left;
                margin-left: 22%;
                margin-top: 150px;
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
    .index {
        .flash {
            position: relative;
            padding: 0 50px;
            .gg .title {
                font-size: 24px;
            }
        }
        .flashImg {
            height: 100vh;
        }  
        .con1 .content {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            img {
                margin-left: 0;
            }
            .content1,.content2,.content3,.content4,.content5,.content6 {
                margin-left: 0;
                margin-top: 0;
            }
        }
        .flex {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .myMl {
                margin-left: 0;
            }
            .minTitle2 {
                flex: 1;
            }
        }
    }
}
@media (max-width: 960px) {
    .index {
        .flash {
            .gg {
                .title {
                    font-size: 20px;
                }
                .minTitle {
                    width: 40%;
                    font-size: 13px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
        } 
        .con1 .content {
            img {
                padding: 30px 0;
                height: 200px;
            }
        }
    }
  }
  @media (max-width: 768px) {
      .index {
          .flash {
              padding: 0 15px;
              .minTitle {
                  width: 50%;
                  font-size: 13px;
              }
              .gg {
                  top: 50px;
                  .title {
                      font-size: 20px;
                  }
                  .button {
                      padding: 6px 15px;
                      margin-top: 20px;
                  }
              }
              
          }
          .flashImg {
              height: 40vh;
          }  
          .contentImg {
              display: none;
          }
          .tc.bg1 {
            background-color: #f6f8ff;
            overflow: hidden;
          }
          .titleNav  {
            margin: 25px auto;
            width: 80%;
            display: flex;
            align-items: center;
            .item {
                width: 50%;
                font-size: 16px;
            }
          }
          .con1 {
          .content {
            padding: 40px 15px;
            min-height: 200px;
            justify-content: space-between;
            img {
                padding: 0 15px;
                width: 50%;
                height: auto;
            }
            .content1,.content2,.content3,.content4,.content5,.content6 {
                width: 50%;
            }
            .title3 {
                font-size: 16px;
            }
            .minTitle2.mt10 {
                font-size: 14px;
                margin-top: 15px;
            }
          }
        }
        .con1:nth-of-type(even) .content {
            flex-direction: row-reverse;
        }
        .content .title {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img {
                width: 25px;
                height: 25px;
                margin-right: 10px;
            }
            .title2 {
                font-size: 14px;
            }
            .title3 {
                font-size: 16px;
                line-height: unset;
            }
        } 
        
        .flex {
            .minTitle2 {
                width: 100%;
                flex: 0 1 100%;
                margin-bottom: 10px;
            }
            .w15 {
                width: 50%;
            }
            .w22 {
                width: 100%;
            }
            .mt5 {
                margin-top: 0;
            }
            .mt10 {
                margin-top: 5px;
            }
            .mt15 {
                margin-top: 0;
            }
            .span2,.span3 {
                width: 100%;
            }
        }
      }
  }
</style>